import { Outlet } from 'react-router-dom';

export default function ApplicationPaymentLayout() {
  return <Outlet />;
}
